module.exports = __webpack_public_path__ + "dfec8297cbb695d21b5e4013bbea964f.pdf";